import React, { useEffect, useMemo } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router';

import { useState } from 'react';
import { useAuth } from './components/auth/AuthProvider';
import MyLoginPage from './components/auth/MyLoginPage';
import { checkToken,getPathFromDB } from './CommonFunctions';
import LateralDashboard from './components/dashboard/LateralDashboard';
import { AuthJson, UserRole } from './types';

function App() {
   const [logged, session] = useAuth();

    //const [token, setToken] = useLocalStorageState('authtoken',undefined);
    const [token, setToken] = useState<any>(localStorage.getItem("attrezapptoken"));
    const [role, setRole] = useState<UserRole>(UserRole.User);

    const logoutfunc = ()=>{
      localStorage.removeItem("attrezapptoken");
      setTimeout(()=>{
        window.location.reload();
      },500);
      return true;
    }

    useEffect(()=>{
      if((token!==undefined)&&(token!==null)){
        localStorage.setItem("attrezapptoken",token);
        getPathFromDB("role",null,token,(jsonresp:AuthJson)=>{

            console.log(jsonresp.role);
            setRole(jsonresp.role.toLowerCase()==="admin"?UserRole.Administrator:UserRole.User);
        
        },(error:any)=>{
          logoutfunc();
        });
      }
    },[token]);
    
    
    if(checkToken(token)) {
      return (<MyLoginPage setToken={setToken} />);
    } else {
      return (<LateralDashboard token={token} role={role} logout={logoutfunc} />);
    }
  
}

export default App;
